<template>
    <div class="shopifyList">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="shopifyList"
            :loading="loading"
            :inputPlaceholder = "inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div
            :class="`table${
                (hasSearchCondition && ' has-search-condition') || ''
            }`"
        >
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
            >
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.batchNo')"
                    prop="batch_no"
                    show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.shopName')"
                    prop="shop_name"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.totalProduct')"
                    prop="total_product"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.success')"
                    prop="s_total"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.fail')"
                    prop="f_total"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    :label="$t('listingRecord.tableName.createTime')"
                    prop="created_at"
                >
                </el-table-column>
                <el-table-column
                    :label="$t('listingRecord.tableName.operation')"
                    align="left"
                    width="200"
                >
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <!-- <add :addVisible.sync="addVisible"></add> -->
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></detail>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import detail from "./listingRecord/detail";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Batch NO.、Shop name",
            searchForm: {
                shop_name: "",
                batch_no: "",
            },
            searchForm_transfer: {
                published_time: "",
            },
            funcName: "listingRecord",
            //addVisible: false,
            detailVisible: false,
            selectList: [],
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        /**
         * 获取table
         */
        listingRecord(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .listingRecord(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                if (item.funcName == "edit") {
                    this.editVisible = true;
                    this.tableItem = row;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                    this.tableItem = row;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        
        /**
          清空高级搜索
        */
        clean() {
            this.searchForm = {
                goods_name: "",
                sku: "",
                itemID: "",
            };
            this.searchForm_transfer = {};
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        tableRowClassName({ row, rowIndex }) {
            let cls = "";
            for (let item of this.selectList.values()) {
                if (item === row.id) cls = "table-selectedRow-bgcolor";
            }
            return cls;
        },
        async initialize() {
            await this.listingRecord();
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        // add: add,
        detail,
    },
    computed: {
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.shopifyList {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .goods-name {
            width: 75%;
            color: $color-333333;
            margin-bottom: 10px;
        }
        .table-selectedRow-bgcolor {
            &:hover td, td {
                background-color: #f0f9eb !important;
            }
        }
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
